function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:#434343;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M183.8,0H86.6c-2.4,0-4.4,2-4.4,4.5v26.7v31.2v31.2v26.7c0,2.5,2,4.5,4.4,4.5h97.1c2.4,0,4.4-2,4.4-4.5V93.5 V62.3V31.2V4.5C188.2,2,186.2,0,183.8,0z"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 82.2,
  y: 31.2,
  className: "st1",
  width: 106,
  height: 31.2
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M188.2,31.2V4.5c0-2.5-2-4.5-4.4-4.5H86.6c-2.4,0-4.4,2-4.4,4.5v26.7H188.2z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M82.2,93.5v26.7c0,2.5,2,4.5,4.4,4.5h97.1c2.4,0,4.4-2,4.4-4.5V93.5H82.2z"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 82.2,
  y: 62.3,
  className: "st4",
  width: 106,
  height: 31.2
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M82.2,26.7L82.2,26.7c-19.5,0-35.3,15.9-35.3,35.6v0c0,19.7,15.8,35.6,35.3,35.6h0c19.5,0,35.3-15.9,35.3-35.6 v0C117.5,42.7,101.7,26.7,82.2,26.7z"
});

var _ref9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M53.1,159l-10.4,31.4h-6.2l-7.8-23.2l-7.9,23.2h-6.2L4.2,159h6.1l7.8,23.9l8.1-23.9h5.4l7.9,24l8-24H53.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M72.8,168.7c1.9,1.7,2.8,4.2,2.8,7.6v14h-5.3v-2.9c-0.7,1-1.7,1.8-2.9,2.4c-1.3,0.6-2.8,0.8-4.6,0.8 c-1.8,0-3.4-0.3-4.7-0.9c-1.3-0.6-2.4-1.5-3.1-2.6c-0.7-1.1-1.1-2.3-1.1-3.7c0-2.2,0.8-3.9,2.4-5.2c1.6-1.3,4.1-2,7.6-2H70V176 c0-1.7-0.5-3-1.5-3.9c-1-0.9-2.5-1.3-4.5-1.3c-1.3,0-2.7,0.2-4,0.6c-1.3,0.4-2.4,1-3.3,1.7l-2.2-4.1c1.3-1,2.8-1.7,4.5-2.2 c1.8-0.5,3.6-0.8,5.6-0.8C68.2,166.2,70.9,167,72.8,168.7z M67.7,185.7c1.1-0.6,1.9-1.6,2.3-2.8v-2.8h-5.8c-3.2,0-4.8,1.1-4.8,3.2 c0,1,0.4,1.8,1.2,2.4c0.8,0.6,1.9,0.9,3.4,0.9C65.3,186.6,66.6,186.3,67.7,185.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M125.8,159l-10.4,31.4h-6.2l-7.8-23.2l-7.9,23.2h-6.2L76.9,159h6.1l7.8,23.9l8.1-23.9h5.4l7.9,24l8-24H125.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M130.5,161.5c-0.7-0.6-1-1.4-1-2.4c0-1,0.3-1.8,1-2.4c0.7-0.6,1.5-1,2.6-1c1,0,1.9,0.3,2.6,0.9 c0.7,0.6,1,1.4,1,2.3c0,1-0.3,1.8-1,2.5s-1.5,1-2.6,1C132.1,162.5,131.2,162.2,130.5,161.5z M130.2,166.4h5.6v24h-5.6V166.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M164.3,182h-17.5l-3.8,8.4h-3.5L154,159h3.3l14.4,31.4h-3.5L164.3,182z M163.1,179.3l-7.5-16.9l-7.5,16.9 H163.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M176.8,189.8c-1.7-0.6-3.1-1.2-4.1-2.1l1.4-2.5c1,0.8,2.2,1.4,3.7,1.9c1.5,0.5,3.1,0.7,4.7,0.7 c2.2,0,3.7-0.3,4.8-1c1-0.7,1.5-1.6,1.5-2.9c0-0.9-0.3-1.5-0.9-2c-0.6-0.5-1.3-0.9-2.2-1.1c-0.9-0.3-2-0.5-3.5-0.7 c-1.9-0.4-3.5-0.7-4.6-1.1c-1.2-0.4-2.2-1-3-1.9c-0.8-0.9-1.2-2.1-1.2-3.7c0-2,0.8-3.6,2.5-4.8c1.6-1.3,3.9-1.9,6.9-1.9 c1.5,0,3.1,0.2,4.6,0.6s2.8,0.9,3.8,1.6l-1.4,2.6c-1.9-1.3-4.3-2-7-2c-2,0-3.6,0.4-4.6,1.1c-1,0.7-1.5,1.7-1.5,2.8 c0,0.9,0.3,1.6,0.9,2.2c0.6,0.5,1.3,0.9,2.2,1.2c0.9,0.3,2.1,0.5,3.6,0.8c1.9,0.4,3.4,0.7,4.5,1.1c1.1,0.4,2.1,1,2.9,1.8 c0.8,0.9,1.2,2.1,1.2,3.6c0,2.1-0.9,3.7-2.6,4.9c-1.7,1.2-4.1,1.8-7.2,1.8C180.3,190.6,178.5,190.4,176.8,189.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M198.7,189.8c-1.7-0.6-3.1-1.2-4.1-2.1l1.4-2.5c1,0.8,2.2,1.4,3.7,1.9c1.5,0.5,3.1,0.7,4.7,0.7 c2.2,0,3.7-0.3,4.8-1c1-0.7,1.5-1.6,1.5-2.9c0-0.9-0.3-1.5-0.9-2c-0.6-0.5-1.3-0.9-2.2-1.1c-0.9-0.3-2-0.5-3.5-0.7 c-1.9-0.4-3.5-0.7-4.6-1.1c-1.2-0.4-2.2-1-3-1.9c-0.8-0.9-1.2-2.1-1.2-3.7c0-2,0.8-3.6,2.5-4.8s3.9-1.9,6.9-1.9 c1.5,0,3.1,0.2,4.6,0.6s2.8,0.9,3.8,1.6l-1.4,2.6c-1.9-1.3-4.3-2-7-2c-2,0-3.6,0.4-4.6,1.1c-1,0.7-1.5,1.7-1.5,2.8 c0,0.9,0.3,1.6,0.9,2.2c0.6,0.5,1.3,0.9,2.2,1.2c0.9,0.3,2.1,0.5,3.6,0.8c1.9,0.4,3.4,0.7,4.5,1.1c1.1,0.4,2.1,1,2.9,1.8 c0.8,0.9,1.2,2.1,1.2,3.6c0,2.1-0.9,3.7-2.6,4.9c-1.7,1.2-4.1,1.8-7.2,1.8C202.3,190.6,200.4,190.4,198.7,189.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M219.8,161c-0.4-0.4-0.7-1-0.7-1.6c0-0.6,0.2-1.1,0.7-1.6c0.4-0.4,1-0.7,1.7-0.7c0.7,0,1.2,0.2,1.7,0.7 c0.4,0.4,0.7,0.9,0.7,1.5c0,0.7-0.2,1.2-0.7,1.7c-0.4,0.4-1,0.7-1.7,0.7C220.8,161.6,220.2,161.4,219.8,161z M219.8,166.8h3.2v23.6 h-3.2V166.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M232.7,189.8c-1.7-0.6-3.1-1.2-4.1-2.1l1.4-2.5c1,0.8,2.2,1.4,3.7,1.9c1.5,0.5,3.1,0.7,4.7,0.7 c2.2,0,3.7-0.3,4.8-1c1-0.7,1.5-1.6,1.5-2.9c0-0.9-0.3-1.5-0.9-2c-0.6-0.5-1.3-0.9-2.2-1.1c-0.9-0.3-2-0.5-3.5-0.7 c-1.9-0.4-3.5-0.7-4.6-1.1c-1.2-0.4-2.2-1-3-1.9c-0.8-0.9-1.2-2.1-1.2-3.7c0-2,0.8-3.6,2.5-4.8c1.6-1.3,3.9-1.9,6.9-1.9 c1.5,0,3.1,0.2,4.6,0.6s2.8,0.9,3.8,1.6l-1.4,2.6c-1.9-1.3-4.3-2-7-2c-2,0-3.6,0.4-4.6,1.1c-1,0.7-1.5,1.7-1.5,2.8 c0,0.9,0.3,1.6,0.9,2.2c0.6,0.5,1.3,0.9,2.2,1.2c0.9,0.3,2.1,0.5,3.6,0.8c1.9,0.4,3.4,0.7,4.5,1.1c1.1,0.4,2.1,1,2.9,1.8 c0.8,0.9,1.2,2.1,1.2,3.6c0,2.1-0.9,3.7-2.6,4.9c-1.7,1.2-4.1,1.8-7.2,1.8C236.3,190.6,234.5,190.4,232.7,189.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M266.2,189c-0.6,0.5-1.3,1-2.2,1.2c-0.9,0.3-1.8,0.4-2.8,0.4c-2.2,0-3.9-0.6-5.1-1.8c-1.2-1.2-1.8-2.9-1.8-5.1 v-14.3h-4.2v-2.7h4.2v-5.2h3.2v5.2h7.2v2.7h-7.2v14.1c0,1.4,0.4,2.5,1.1,3.2c0.7,0.7,1.7,1.1,3,1.1c0.7,0,1.3-0.1,1.9-0.3 c0.6-0.2,1.1-0.5,1.6-0.9L266.2,189z"
}));

var SvgLogoFakturaAssist = function SvgLogoFakturaAssist(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 270.4 191",
    style: {
      enableBackground: "new 0 0 270.4 191"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.2069,
    y1: 62.3235,
    x2: 188.1751,
    y2: 62.3235
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FD2724"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C60008"
    }
  })), _ref3, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.2069,
    y1: 46.7426,
    x2: 188.1751,
    y2: 46.7426
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C60008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FD2724"
    }
  })), _ref4, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.2069,
    y1: 15.5809,
    x2: 188.1751,
    y2: 15.5809
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FD2724"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C60008"
    }
  })), _ref5, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -7656.186,
    y1: -11010.8164,
    x2: -7550.2178,
    y2: -11010.8164,
    gradientTransform: "matrix(-1 0 0 -1 -7468.0107 -10901.75)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FD2724"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C60008"
    }
  })), _ref6, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.2069,
    y1: 77.9044,
    x2: 188.1751,
    y2: 77.9044
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FD2724"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C60008"
    }
  })), _ref7)), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.8841,
    y1: 62.3235,
    x2: 117.5296,
    y2: 62.3235
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FD2724"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C60008"
    }
  })), _ref8, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M108.2,48.7L97.5,81.6h-8.1l-7.2-22.3l-7.4,22.3h-8.1L56,48.7h7.8l7.4,23.1l7.7-23.1h7L93.4,72l7.6-23.3 H108.2z"
  }))), _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoFakturaAssist, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-faktura-assist.b9c1d72a.svg";
export { ForwardRef as ReactComponent };